/**
 * Created by Carsten Hibbeler on 14.09.2016.
 * Copyright: xdot GmbH 2015
 */

import { AppContext } from '../app-context';

import { amdRequire } from './amd-utils';

import ActionTypesCommon from '../constants/ActionTypesCommon';
import { activeStores } from '../actions/RemoteDataActions';

let DataEventSocket = undefined;

//Connect the FLIWAS-Objects to the Websockets needed for States and Measurements
let ADDITIONAL_TOPICS = {
    Group: [ 'StateValue', 'Organization' ],
    FloodProtectionObjectPoint: [ 'StateValue' ],
    FloodProtectionObjectLine: [ 'StateValue' ],
    CriticalObject: [ 'StateValue' ],
    FloodRetentionBasin: [ 'StateValue', 'BasinFillLevel', 'BasinFillDegree', 'WaterLevel', 'WaterFlow' ],
    PrecipitationStation: [ 'StateValue', 'PrecipitationValue' ],
    RealPrecipitationStation: [ 'StateValue', 'PrecipitationValue' ],
    GaugingStation: [ 'StateValue', 'WaterLevel', 'WaterFlow' ],
};

function onMessageCb(modelUpdate) {
    AppContext.getDispatcher().dispatch({
        type: ActionTypesCommon.DATA_UPDATE_MESSAGE,
        payload: modelUpdate
    });
}

if (!AppContext.getWebsocketUnsupported()) {
    amdRequire([ 'DataEventSocketSupport' ], (module) => {
        if (module && module.DataEventSocket) {
            DataEventSocket = new module.DataEventSocket({ onMessageCb });
            DataEventSocket.connect(
                () => {
                    AppContext.getDispatcher().registerAfterDispatchListener(connectDataListener);
                    connectDataListener();
                }
            );
        } else {
            AppContext.setWebsocketConnected(() => DataEventSocket.isConnected());
            AppContext.getDispatcher().registerAfterDispatchListener(() => {
                //Todo do something about async--event-chains like change-records
            });
        }
    }, (err) => {
        console.info('DataEvebntsocketSupport invalid', err);

        AppContext.setWebsocketUnsupported(true);
        AppContext.getDispatcher().registerAfterDispatchListener(() => {
            //Todo do something about async--event-chains like change-records
        });
    });

}

function connectDataListener() {
    const classNames = {};
    activeStores().forEach(store => {
        if (store.getContainedClassnames) {
            Object.keys(store.getContainedClassnames()).forEach(className => {
                classNames[className] = true;
            });
        }
    });
    registerClassNames(classNames);
}

function registerClassNames(classNames) {
    const all = {};
    Object.keys(classNames).forEach(cn => {
        all[cn] = true;
        if (ADDITIONAL_TOPICS[cn]) {
            ADDITIONAL_TOPICS[cn].forEach(c => all[c] = true);
        }
    });
    DataEventSocket.registerTopics(Object.keys(all));
}





// WEBPACK FOOTER //
// ./js/utils/DataEventSocketSupport.js